<template>
  <div>
    <Header :notHome="true" @goScroll="goScroll"></Header>
    <pageNav :navList="navList" :current="currentActive" title="新闻动态" @navClick="navClick"></pageNav>
    <div class="main-content-area">
    <!-- 中心资讯 -->
    <div class="centerNews-area" ref="area0">
      <div class="centerNews-box">
        <b-container fluid>
          <b-row class="page-model-title-row">
            <b-col xl="12">
              <div class="page-model-title-line flex justify-between align-center">
                <div class="page-model-title">
                  <span>01.</span>
                  <span>中心资讯</span>
                </div>
                <div class="page-model-right flex align-center" @click="goPage(0)" v-if="dataList[0]&&dataList[0].length!=0">
                  <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                  <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                  <img src="../../assets/image/icon8.png" />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="show-news-list page-middle-content-row">
            <b-col xl="4" sm="12" v-for="(item, index) in dataList[0]" :key="index">
              <!-- pc -->
              <div class="news-item-area d-sm-none d-xl-block" @click="goDetail(item,0)">
                <div class="flex justify-center">
                  <div class="news-item">
                    <div class="news-item-img  flex align-center justify-center">
                      <img :src="$BaseUrl+item.image" />
                    </div>
                    <div class="news-item-title overHidden">
                      {{ item.title }}
                    </div>
                    <div class="news-item-date">
                      {{item.publishDate.substring(0,10).replace(/-/g,'/')}}
                    </div>
                    <div class="news-item-content overHidden2">
                      {{ item.desc }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- h5 -->
              <div class="news-item-area sm-news-item-area  d-sm-block d-xl-none" @click="goDetail(item,0,true)">
                <div class="flex sm-news-item">
                  <div class="news-item">
                    <div class="news-item-img flex align-center justify-center">
                      <img :src="$BaseUrl+item.image" />
                    </div>
                  </div>
                  <div class="news-item-right flex flex-column justify-between">
                    <div class="news-item-title overHidden2">
                      {{ item.title }}
                    </div>
                    <div class="news-item-date">
                      {{ (item.publishDate||'').substring(0,10).replace(/-/g,'/') }}
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- 最新新闻 -->
    <div class="newNews-area" ref="area1">
      <div class="newNews-box">
        <b-container fluid>
          <b-row class="page-model-title-row">
            <b-col xl="12">
              <div class="page-model-title-line flex justify-between align-center">
                <div class="page-model-title">
                  <span>02.</span>
                  <span>最新新闻</span>
                </div>
                <div class="page-model-right flex align-center" @click="goPage(1)" v-if="dataList[1]&&dataList[1].length!=0">
                  <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                  <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                  <img src="../../assets/image/icon8.png" />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="dataList[1]&&dataList[1].length!=0" class="page-middle-content-row">
            <b-col xl="6" sm="12">
              <el-carousel :interval="5000" arrow="never" :autoplay="autoplay" indicator-position="none" @change="changeNewSwiper" loop ref="newsSwiper">
                <el-carousel-item v-for="(item, index) in dataList[1]" :key="index" >
                  <div class="img-box flex align-center justify-center" @click="goDetail(dataList[1][0],1)">
                <img :src="$BaseUrl+item.image">
                <div class="img-title d-sm-none d-xl-block">
                  {{ item.title }}
                </div>
                <div class="img-title d-sm-block d-xl-none">
                  {{ item.title }}
                </div>
              </div>
                  </el-carousel-item>
              </el-carousel>
            </b-col>
            <b-col xl="6" sm="12">
              <div class="newNew-item-list flex flex-column justify-between">
                <div class="newNew-item flex align-center justify-between" v-for="(item, index) in dataList[1]" :key="index+22" @click="goDetail(item,1)" :class="{'active-item': newNewsIdx == index}" @mouseenter="handleMouseEnter(index)" @mouseleave="handleMouseLeave">
                  <div class="d-sm-block d-xl-none newNew-item-title">
                    <div class="overHidden">{{ item.title }}</div>
                  </div>
                  <div class="d-sm-none d-xl-block newNew-item-title">
                    <div class="overHidden2">{{ item.title }}</div>
                  </div>
                  <span>{{ (item.publishDate||'').replace(/-/g,'/').substring(0,10) }}</span>
                  <div class="newNew-bg"></div>
                </div>
                <div v-for="(item,index)  in (3 - (dataList[1].length))" :key="index" class="newNew-item">

                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- 行业动态 -->
    <div class="dynamics-area" ref="area2">
      <div class="dynamics-box">
        <b-container fluid>
          <b-row class="page-model-title-row">
            <b-col xl="12">
              <div class="page-model-title-line flex justify-between align-center">
                <div class="page-model-title">
                  <span>03.</span>
                  <span>行业动态</span>
                </div>
                <div class="page-model-right flex align-center" @click="goPage(2)" v-if="dataList[2]&&dataList[2].length!=0">
                  <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                  <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                  <img src="../../assets/image/icon8.png" />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="page-middle-content-row">
            <b-col xl="12">
              <div class="dynamics-item flex" v-for="(item, index) in dataList[2]" :key="index+33" @click="goDetail(item,2)">
                <div class="dynamics-item-left flex align-center">
                  <div class="dynamics-item-date d-sm-none d-xl-block">
                    <div class="flex flex-column">
                      <span>{{item.showTime?item.showTime[0]:''}}</span>
                      <span>{{item.showTime?item.showTime[1]:''}}</span>
                    </div>
                  </div>
                  <!-- <div class="dynamics-item-date flex flex-column d-sm-none d-xl-block">
                                    <span>2022</span>
                                    <span>05-20</span>
                                </div> -->
                  <div class="dynamics-item-content flex flex-column justify-between">
                    <div class="dynamics-item-title overHidden2">
                      {{item.title}}
                    </div>
                    <div class="dynamics-item-contentDate  d-sm-block d-xl-none">
                      {{item.publishDate.substring(0,10).replace(/-/g,'/')}}
                    </div>
                    <!-- pc -->
                    <div class="dynamics-item-desc d-sm-none d-xl-block">
                      <div class="overHidden2">
                        {{item.desc}}
                      </div>
                    </div>
                    <!-- h5 -->
                    <div class="dynamics-item-desc d-sm-block d-xl-none">
                      <div class="overHidden">
                        {{item.desc}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dynamics-item-img flex align-center justify-center">
                  <img :src="$BaseUrl+item.image" />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- 通知公告 -->
    <div class="notice-area" ref="area3">
      <div class="notice-box">
        <b-container fluid>
          <b-row class="page-model-title-row">
            <b-col xl="12">
              <div class="page-model-title-line flex justify-between align-center">
                <div class="page-model-title">
                  <span>04.</span>
                  <span>通知公告</span>
                </div>
                <div class="page-model-right flex align-center" @click="goPage(3)" v-if="dataList[3]&&dataList[3].length!=0">
                  <span class="page-model-right-info d-sm-none d-xl-block">查看更多</span>
                  <span class="page-model-right-info d-sm-block d-xl-none">更多</span>
                  <img src="../../assets/image/icon8.png" />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="page-middle-content-row">
            <b-col sm="12" >
              <div class="test" @click="scrollclick($event)">
              <vue-seamless-scroll :data="dataList[3]" :class-option="defineScroll" :key="scrollViewKey">
                <div class="flex align-center notice-scroll-list">
                  <div class="notice-scroll-item flex flex-column" v-for="(item, index) in dataList[3]" :key="index+44" :data="JSON.stringify(item)">
                    <div class="notice-img flex align-center justify-center" :class="{'noImg':!item.image}">
                      <img :src="item.image?($BaseUrl+item.image):'../../assets/image/icon24.png'" />
                    </div>
                    <div class="d-sm-none d-xl-block notice-title">
                      <div class="flex align-end">
                        <div class="overHidden2">{{ item.title }}</div>
                      </div>
                    </div>
                    <div class="d-sm-block d-xl-none sm-notice-title">
                      <div class="overHidden">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </vue-seamless-scroll>
            </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    </div>
    <Footer @goScroll="goScroll"></Footer>
  </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { getNewsList } from "@/api/news"
export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      navList: [{
        title: '中心资讯'
      }, {
        title: '最新新闻'
      }, {
        title: '行业动态'
      }, {
        title: '通知公告'
      }],
      currentActive: 0,
      defineScroll: {
        step: 0.4, // 数值越大速度滚动越快
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动)direction => 0/1                                
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      },
      dataList: [[], [], [], []],
      topList:[],
      stopScroll:false,
      stopScrollTimeout:null,
      newNewsIdx:0,
      autoplay:true,
      scrollViewKey:-1
    }
  },
  mounted() {
    this.countViewCount()
    this.getNews()
    window.addEventListener('resize', this.resizeRefreshScorllView);
  },
  destroyed(){
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener('resize', this.resizeRefreshScorllView);
  },
  methods: {
    navClick({ item, index }) {
      this.stopScroll=true
      if(this.stopScrollTimeout)clearTimeout(this.stopScrollTimeout)
      this.currentActive = index
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollByRef(`area${index}`)
        }, 100)
        this.stopScrollTimeout = setTimeout(() => {
          this.stopScroll = false
        }, 1100)
      })
    },
    getNews() {
      getNewsList().then(response => {
        if (response.code == 200) {
          let res = response.data
          let temp = [[], [], [], []]
          res.forEach(v => {
            if (v.name == '中心资讯') {
              temp.splice(0, 1, v.list)
            } else if (v.name == '最新新闻') {
              temp.splice(1, 1, v.list)
            } else if (v.name == '行业动态') {
              temp.splice(2, 1, v.list)
            } else if (v.name == '通知公告') {
              temp.splice(3, 1, v.list)
            }
          })
          this.dataList = temp
          if (this.dataList[0]&&this.dataList[0].length > 3) {
            this.dataList[0] = this.dataList[0].slice(0, 3)
          }
          if (this.dataList[1]&&this.dataList[1].length > 3) {
            this.dataList[1] = this.dataList[1].slice(0, 3)
          }
          if (this.dataList[2]&&this.dataList[2].length > 3) {
            this.dataList[2] = this.dataList[2].slice(0, 3)
          }
          this.dataList[0] = this.dataList[0].map(v => {
            v.desc = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
            return v
          })
          this.dataList[2] = this.dataList[2].map(t => {
            let d = t.publishDate.substring(0, 10).split('-')
            t.showTime = [d[0], `${d[1]}-${d[2]}`]
            t.desc = (t.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
            return t
          })
          this.$nextTick(() => {
            if (this.$route.query.to != undefined) {
              this.navClick({ index: Number(this.$route.query.to) })
              setTimeout(()=>{
                window.addEventListener("scroll", this.handleScroll)
              },1000)
            }else{
              window.addEventListener("scroll", this.handleScroll)
            }
          })
        }
      })
    },
    goPage(index) {
      let temp = this.dataList[index][0]
      this.$router.push({ path: '/newsList?categoryOne=' + temp.categoryOne + '&categoryTwo=' + temp.categoryTwo + '&type=news&scroll=' + index })
    },
    goDetail(item, index,flag) {
      let pageName = ['中心资讯', '最新新闻', '行业动态', '通知公告'][index]
      setTimeout(()=>{
        this.$router.push({ path: `/newsDetail?contentId=${item.contentId}&type=news&=pageName=${pageName}&scroll=${index}` })
      },(flag?500:0))
    },
    goScroll(index){
      this.navClick({ index: Number(index) })
    },
    handleScroll(e){
      if(this.stopScroll){
        return
      }
      let nowTop = e.target.scrollTop || document.documentElement.scrollTop
      if(this.topList.length==0){
        for(let i=0;i<4;i++){
          this.topList.push(this.$refs[`area${i}`].offsetTop-200)
        }
      }
      let temp=this.currentActive
      let result=this.topList.reduce((res,curV,curVindex)=>{
        if(nowTop>=curV){
          res=curVindex
        }
        return res
      },temp)
      // 获取距离顶部的距离
      let scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      // 获取可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 获取滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      if(scrollTop+windowHeight>=scrollHeight){
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部                    
        result=this.topList.length-1
      }
      this.currentActive=result
      // console.log(this.topList)
    },
    scrollclick(e){
      const path = e.path || (e.composedPath && e.composedPath());
      let target = path.filter((r) => /notice-scroll-item/.test(r.className));
      if (target.length) target = target[0];
      else return;
      const data = JSON.parse(target.getAttribute("data")); // 单项数据详情
      this.goDetail(data,3)
    },
    changeNewSwiper(e){
      this.newNewsIdx=e
    },
    handleMouseEnter(index){
      this.autoplay=false
      this.newNewsIdx=index
      this.$refs.newsSwiper.setActiveItem(this.newNewsIdx)
    },
    handleMouseLeave(){
      this.autoplay=true
    },
    resizeRefreshScorllView(){
      this.scrollViewKey=Math.random()
    }
  }
}
</script>
<style lang="scss" scoped>
.centerNews-area {
  background-image: url("../../assets/image/bg6.png");
  background-size: cover;
  width: 100%;
  min-height: 600px;

  .centerNews-box {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    .show-news-list{
      margin-top: 30px;
      >div{
        padding: 0;
      }
    }
  }

  .news-item-area {
     
    .news-item {
      background: #fff;
      // width: 285px;
      // width: 370px;
      width: calc(100% - 20px);
      // margin-right: 20px;
      overflow: hidden;
      padding-bottom: 15px;
      cursor: pointer;

      .news-item-img {
        // width: 285px;
        width: 100%;
        height: 214px;
        overflow: hidden;

        img {
          object-fit: cover;
          // width: 285px;
          width: 100%;
          height: 214px;
        }
      }

      .news-item-title {
        font-family: "SourceHanSansCN-Regular";
        font-weight: bold;
        font-size: 24px;
        color: #333333;
        line-height: 36px;
        padding: 15px 15px 5px 15px;
        overflow: hidden;
      }

      .news-item-date {
        font-family: "SourceHanSansCN-Regular";
        font-size: 20px;
        color: #999999;
        line-height: 30px;
        padding-left: 15px;
      }

      .news-item-content {
        font-family: "SourceHanSansCN-Regular";
        font-size: 20px;
        color: #666666;
        line-height: 30px;
        padding: 5px 15px 0 15px;
        min-height: 52px;
      }
    }

    .news-item:hover {
      background: #1566d4;

      .news-item-title {
        color: #fff;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-wrap: wrap;
      }

      .news-item-date {
        color: rgba(255, 255, 255, 0.6);
      }

      .news-item-content {
        color: #fff;
      }
    }
  }

  .sm-news-item-area {
    width: 100%;
    .sm-news-item{
      margin-top: 20px;
      height: 138px;
      padding: 0 15px;
    }
    .sm-news-item::first-of-type{
      margin-top: 0;
    }
    .news-item {
      flex-shrink: 0;
      width: 246px;
      .news-item-img{
        width: 246px;
        height: 138px;
        object-fit: cover
      }
    }

    .news-item-right {
      flex: 1;
      min-width: 0;
      background: #fff;
      padding: 15px 20px;

      .news-item-title {
        font-weight: bold;
        font-size: 26px;
        color: #333333;
      }

      .news-item-date {
        font-size: 20px;
      }
    }
    .news-item:hover {
      .news-item-right {
        background: #1566d4;

        .news-item-title {
          color: #fff;
        }
      }
    }
  }
}

// 最新新闻
.newNews-area {
  background-image: url("../../assets/image/bg7.png");
  background-size: cover;
  width: 100%;
  min-height: 442px;
  padding-bottom: 60px;

  .newNews-box {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    /deep/.el-carousel__container {
    // height: 800px;
    min-height: 327px;
    margin-top: 30px;
  }
    .img-box {
      min-width: 580px;
      min-height: 327px;
      margin: 0 auto;
      position: relative;
      // margin-top: 30px;
      background: #fff;

      img {
        width: 100%;
        object-fit: cover;
        height: 327px;
        // min-width: 435px;
        // min-height: 245px;
      }

      .img-title {
        width: 100%;
        position: absolute;
        bottom: 0;
        padding: 20px 15px;
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 15px;
        color: #ffffff;
        background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
      }
    }

    .newNew-item-list {
      width: 100%;
      height: 327px;
      margin-top: 30px;
      padding-left: 20px;;
      .newNew-item {
        height: 109px;
        position: relative;
        z-index: 3;
        cursor: pointer;
        overflow: hidden;
        
        .newNew-item-title{
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          padding-left: 15px;
          z-index: 4;
          min-width: 0;
        }

        > span:last-of-type {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 500;
          font-size: 18px;
          color: #999999;
          padding-right: 15px;
          z-index: 4;
          flex-shrink: 0;
        }

        .newNew-bg {
          position: absolute;
          z-index: 2;
          height: 3px;
          width: 100%;
          bottom: 0;
          background: #ffffff;
          border-left: 4px solid #1566d4;
        }
      }

      .active-item {
        .newNew-item-title {
          color: #1566d4 !important;
        }

        .newNew-bg {
          animation-name: changeNewNewsBg;
          animation-duration: 0.3s;
          animation-iterationcount: 1;
          height: 109px;
          z-index: 2;
        }
      }
    }
  }
}

// 行业动态
.dynamics-area {
  background-image: url("../../assets/image/bg9.png");
  background-size: cover;
  width: 100%;
  min-height: 700px;
  padding-bottom: 60px;
  padding-top: 60px;

  .dynamics-box {
    max-width: 1200px;
    margin: 0 auto;

    .dynamics-item {
      width: 100%;
      background: #fff;
      margin-bottom: 15px;
      box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
      // border: 1px solid rgba(153, 153, 153, 0.5);
      overflow: hidden;
      cursor: pointer;

      .dynamics-item-left {
        padding: 20px 0;
        flex: 1;
        min-width: 0;
        overflow: hidden;
      }

      &-date {
        padding: 35px 0;
        min-width: 170px;
        border-right: 3px solid rgba(153, 153, 153, 0.5);
        flex-shrink: 0;

        > div {
          > span:first-of-type {
            text-align: center;
            font-family: "SourceHanSansCN-Regular";
            font-weight: bold;
            font-size: 33px;
            color: #333333;
            line-height: 41px;
          }

          > span:last-of-type {
            text-align: center;
            font-family: "SourceHanSansCN-Regular";
            font-weight: 400;
            font-size: 22px;
            color: #666666;
            line-height: 25px;
          }
        }
      }

      &-content {
        height: 174px;
        padding: 10px 20px;
        flex: 1;
        min-width: 0;
        overflow: hidden;

        .dynamics-item-title {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size:  24px;
          color: #333333;
          // min-height: 51px;
        }

        .dynamics-item-contentDate {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 20px;
          color: #999999;
        }

        .dynamics-item-desc {
          font-family: "SourceHanSansCN-Regular";
          font-size: 20px;
          color: #666666;
          min-height: 64px;
          overflow: hidden;
          // span{
          //   display: inline-block;
          //   width: 100%;
          // }
        }
      }

      &-img {
        width: 380px;
        height: 214px;
        flex-shrink: 0;

        img {
          width: 380px;
          height: 214px;
          object-fit: cover
        }
      }
    }

    .dynamics-item:first-of-type {
      margin-top: 30px;
    }

    .dynamics-item:last-of-type {
      margin-bottom: 0;
    }

    .dynamics-item:hover {
      background-color: #1566d4;

      .dynamics-item-date {
        > div {
          > span:first-of-type {
            color: #fff;
          }

          > span:last-of-type {
            color: rgba(255, 255, 255, 0.6);
          }
        }
      }

      .dynamics-item-content {
        .dynamics-item-title {
          color: #fff;
        }

        .dynamics-item-desc {
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }
}

// 通知公告
.notice-area {
  background-image: url("../../assets/image/bg8.png");
  background-size: cover;
  width: 100%;
  min-height: 358px;
  padding-bottom: 60px;
  padding-top: 60px;

  .notice-box {
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;

    .notice-scroll-list {
      width: 100%;
      overflow: hidden;
      margin-top: 30px;
      flex-wrap: nowrap;

      .notice-scroll-item {
        position: relative;
        cursor: pointer;
        margin-right: 15px;
        .notice-img {
          width: 285px;
          height: 161px;
          overflow: hidden;
          img {
            width: 285px;
            height: 161px;
            object-fit: cover
          }
        }
        .noImg{
          img{
            object-fit: contain;
          }
        }

        .notice-title {
          width: 100%;
          height: 161px;
          overflow: hidden;
          padding: 18px 15px;
          font-family: "SourceHanSansCN-Regular";
          position: absolute;
          bottom: 0;
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
          line-height: 23px;
          background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
          >div{
            display: inline-block;
            height: 161px;
            display: flex;
            align-items: flex-end;
            padding-bottom: 30px;
          }
        }

        .sm-notice-title {
          width: 285px;
          font-weight: 500;
          font-size: 26px;
          color: #333333;
        }
      }
      .notice-scroll-item:hover{
        .notice-title {
          background: linear-gradient( 180deg, rgba(21,102,212,0) 0%, #1566D4 100%);
        }
      }
    }
  }
}

@keyframes changeNewNewsBg {
  from {
    height: 3px;
  }

  16% {
    height: 19px;
  }

  33% {
    height: 37px;
  }

  48% {
    height: 55px;
  }

  66% {
    height: 73px;
  }

  84% {
    height:97px;
  }

  to {
    height: 109px;
  }
}

// 移动端
@media (min-width: 576px)and (max-width:1200px){
  // 中心资讯
  .centerNews-area{
    .news-item-area{
    .sm-news-item{
      .news-item{
        height: 144px!important;
      }
      .news-item-img{
        width: 256px!important;
          height: 144px!important;
        img{
          width: 256px!important;
          height: 144px!important;
        }
      }
      .news-item-right{
        height: 144px;
      }
    }
    .sm-news-item:hover {
      .news-item-right{
        background: #1566d4;
      }
      .news-item-title {
        color: #fff;
      }

      .news-item-date {
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
  }
  // 最新新闻
  .newNews-area{
    /deep/.el-carousel__container {
    // height: 800px;
    min-height: 396px!important; 
    margin-top: 30px;
  }
    .img-box{
      max-width: 702px;
      height: 396px;
      img{
      max-width: 702px!important;
      height: 396px!important;  
      object-fit: cover;   
      }
      .img-title{
        font-size: 26px!important;
      }
    }
    .newNew-item-list{
      padding: 0!important;
    }
    .newNew-item{
      flex-direction: column!important;
      justify-content: center!important;
      align-items: flex-start!important;
      overflow: hidden;
      span{
        padding:0 20px;
        text-align: left;
      }
      .newNew-item-title{
        padding:0 20px;
        font-size: 26px!important;
        overflow: hidden;
        width: 100%;
      }
      >span:first-of-type{
        font-size: 20px!important;
        padding-left: 20px;
        margin-top: 14px;
      }
    }
    // 26px
  }
  // 行业动态
  .dynamics-area {
  .dynamics-box {
    .dynamics-item {
      .dynamics-item-left {
        padding: 20px 0;
        flex: 1;
        min-width: 0;
        overflow: hidden;
      }

      &-content {
        height: 150px;
        padding: 0 20px;
        .dynamics-item-desc {
          min-height: 0;
        }
      }

      &-img {
        width: 341px;
        height: 192px;


        img {
          width: 341px;
          height: 192px;
        }
      }
    }
  }



}
  // 通知公告
  .notice-area{
    .notice-img{
      width: 380px!important;
      height: 215px!important;
      img{
        width: 380px!important;
      height: 215px!important;      
      }
    }
    .sm-notice-title{
      width: 380px!important;
        text-align: center;
      font-size: 26px!important;
      line-height: 39px!important;
      margin-top: 10px;
    }
  }
}
</style>